<script lang="ts">
	import { inputFieldFormats } from '../utils/formatters'
	import { DefaultInputFieldProps, getFontPropsVarString } from '../types/fontProps'
	import type { FontProps } from '../types/fontProps'
	import { getContext, hasContext } from 'svelte'

	export let useMaterialDesign: boolean = hasContext('useMaterialDesign')
		? getContext('useMaterialDesign')
		: false

	export let id: string = 'input-id' + Math.random().toString(16).slice(2)
	export let value: number | string | undefined | null
	export let format = inputFieldFormats.NORMAL
	export let placeholder: string | number = ''
	export let borderless: boolean = false
	export let fontProps: FontProps = DefaultInputFieldProps()
	export let readOnly: boolean = false
	export let materialWidth: string = '100%'
	export let materialLabel: string = ''
	export let errorHighlight: boolean = false
	export let min: number | undefined = undefined
	export let max: number | undefined = undefined
	export let step: number | undefined = undefined

	$: fontPropsStyleString = getFontPropsVarString(fontProps)
	$: notEmpty = value !== undefined && value !== null && value !== ''
</script>

{#if useMaterialDesign}
	<div class="material-design" style="{fontPropsStyleString}; --input-width: {materialWidth}">
		<input
			{id}
			type="number"
			name={id}
			aria-labelledby="label-{id}"
			class:borderless
			class:notEmpty
			class={errorHighlight && !notEmpty ? 'material-design-error' : ''}
			bind:value
			disabled={readOnly}
			placeholder={placeholder !== '' ? String(placeholder) : ''}
			{min}
			{max}
			{step}
			on:input
			on:focusout
			on:keydown
			on:change
			on:focus
		/>
		<label class="material-label" for={id} id="label-{id}">
			<div class="material-text">{materialLabel}</div>
		</label>
	</div>
{:else}
	<input
		{id}
		type="number"
		class="input-field-focus {errorHighlight && !notEmpty ? 'input-field-error' : ''}"
		class:borderless
		style="width: {format.maxWidth}; max-width: {format.maxWidth}; {fontPropsStyleString}"
		bind:value
		disabled={readOnly}
		placeholder={placeholder !== '' ? String(placeholder) : null}
		{min}
		{max}
		{step}
		on:focusout
		on:input
		on:keydown
		on:change
		on:focus
	/>
{/if}

<style lang="scss">
	@import '$styles/global';
	@import '$styles/inputFields';

	input {
		height: 32px;

		&::-webkit-outer-spin-button,
		&::-webkit-inner-spin-button {
			appearance: none;
			margin: 0;
		}

		&[type='number'] {
			appearance: textfield;
		}
	}
</style>
